// // import React, { useState, useEffect } from 'react';
// // import { Building2, Users, Award, TrendingUp, CheckCircle, ArrowRight } from 'lucide-react';

// // const VedamsaAboutPage = () => {
// //   const [scrolled, setScrolled] = useState(false);

// //   useEffect(() => {
// //     const handleScroll = () => {
// //       setScrolled(window.scrollY > 50);
// //     };
// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   const stats = [
// //     { number: '30', suffix: '+', text: 'Projects Completed' },
// //     { number: '70', suffix: '+', text: 'Happy Customers' },
// //     { number: '3,000', suffix: '+', text: 'Upcoming Projects' },
// //     { number: '2', suffix: '', text: 'Decades of Excellence' }
// //   ];

// //   const coreValues = [
// //     {
// //       icon: <Building2 className="w-12 h-12" />,
// //       title: 'Quality',
// //       description: 'We use the finest materials and employ stringent quality control measures to ensure that every project we undertake meets the highest standards of excellence.'
// //     },
// //     {
// //       icon: <TrendingUp className="w-12 h-12" />,
// //       title: 'Innovation',
// //       description: 'We embrace new technologies and innovative construction methods to deliver projects that are aesthetically pleasing but also sustainable and durable.'
// //     },
// //     {
// //       icon: <CheckCircle className="w-12 h-12" />,
// //       title: 'Transparency',
// //       description: 'We maintain open and honest communication with our clients, ensuring they are informed and involved at every stage of the construction process.'
// //     },
// //     {
// //       icon: <Users className="w-12 h-12" />,
// //       title: 'Community',
// //       description: 'We are committed to contributing positively to the neighborhoods we serve, creating spaces where life unfolds and communities thrive.'
// //     }
// //   ];

// //   return (
// //     <div className="min-h-screen bg-[#f5f3f0]">
// //       {/* Header */}
// //       <header 
// //         className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
// //           scrolled 
// //             ? 'bg-white shadow-lg py-4' 
// //             : 'bg-white/95 backdrop-blur-sm py-6'
// //         }`}
// //       >
// //         <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
// //           {/* Logo */}
// //           <div className="flex items-center space-x-3">
// //             <div className="bg-black text-white p-2 rounded">
// //               <Building2 className="w-6 h-6" />
// //             </div>
// //             <span className="text-2xl font-bold text-gray-900">Vedamsa</span>
// //           </div>

// //           {/* Navigation */}
// //           <nav className="hidden md:flex items-center space-x-8">
// //             <a href="#overview" className="text-gray-700 hover:text-gray-900 transition-colors duration-300 font-medium">
// //               Overview
// //             </a>
// //             <a href="#pages" className="text-gray-700 hover:text-gray-900 transition-colors duration-300 font-medium">
// //               Pages
// //             </a>
// //             <a href="#projects" className="text-gray-700 hover:text-gray-900 transition-colors duration-300 font-medium">
// //               Projects
// //             </a>
// //           </nav>

// //           {/* CTA Buttons */}
// //           <div className="flex items-center space-x-4">
// //             <button className="hidden md:block text-gray-700 hover:text-gray-900 transition-colors duration-300">
// //               <span className="text-2xl">ⓘ</span>
// //             </button>
// //             <button className="bg-gray-200 text-gray-900 px-6 py-2.5 rounded-lg font-medium hover:bg-gray-300 transition-all duration-300">
// //               More Templates
// //             </button>
// //             <button className="bg-[#3d2817] text-white px-6 py-2.5 rounded-lg font-medium hover:bg-[#2d1f10] transition-all duration-300">
// //               Contact Us
// //             </button>
// //           </div>
// //         </div>
// //       </header>

// //       {/* Hero Section with Split Layout */}
// //       <section className="pt-32 pb-20 px-6">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
// //             {/* Left - Image */}
// //             <div className="relative overflow-hidden rounded-2xl shadow-2xl group">
// //               <img 
// //                 src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800"
// //                 alt="Modern Living Space"
// //                 className="w-full h-[600px] object-cover transform group-hover:scale-105 transition-transform duration-700"
// //               />
// //               <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
// //             </div>

// //             {/* Right - Content */}
// //             <div>
// //               <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
// //                 [ABOUT]
// //               </span>
// //               <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
// //                 Modern Living,<br />
// //                 Thoughtfully Designed
// //               </h1>
// //               <p className="text-gray-600 text-lg leading-relaxed mb-8">
// //                 At Vedamsa, our mission is to connect people with exceptional properties through transparent, trustworthy, and personalized service. We believe that finding a home is about more than just walls and roofs — it's about creating a space where life unfolds.
// //               </p>
// //               <button className="group bg-[#f5f3f0] border-2 border-gray-900 text-gray-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-900 hover:text-white transition-all duration-300 flex items-center space-x-2">
// //                 <span>Meet the Team</span>
// //                 <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Legacy Section */}
// //       <section className="py-20 px-6 bg-white">
// //         <div className="max-w-6xl mx-auto text-center">
// //           <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
// //             [OUR LEGACY]
// //           </span>
// //           <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
// //             Nearly 30 Years of Excellence
// //           </h2>
// //           <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto mb-12">
// //             Welcome to Vedamsa, a premier construction company in Hyderabad with a nearly 30-year legacy of excellence and trust. Over this period, Vedamsa has become synonymous with quality, reliability, and customer satisfaction in plotting and construction. With an impressive portfolio and a track record of over 3000 happy customers, we stand as a testament to what dedication, expertise, and commitment can achieve.
// //           </p>
// //         </div>
// //       </section>

// //       {/* Stats Section - Split Layout */}
// //       <section className="py-20 px-6 bg-[#f5f3f0]">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
// //             {/* Left - Image */}
// //             <div className="relative overflow-hidden rounded-2xl shadow-2xl group order-2 lg:order-1">
// //               <img 
// //                 src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800"
// //                 alt="Our Commitment"
// //                 className="w-full h-[700px] object-cover transform group-hover:scale-105 transition-transform duration-700"
// //               />
// //               <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
// //             </div>

// //             {/* Right - Stats & Content */}
// //             <div className="order-1 lg:order-2">
// //               <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
// //                 [WHY VEDAMSA]
// //               </span>
// //               <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
// //                 Our Commitment to You
// //               </h2>
// //               <p className="text-gray-600 text-lg leading-relaxed mb-12">
// //                 Vedamsa empowers modern property management teams and real estate professionals to simplify operations, increase efficiency, and connect clients with their ideal homes—without unnecessary complexity.
// //               </p>

// //               {/* Stats Grid */}
// //               <div className="grid grid-cols-3 gap-8 mb-12">
// //                 <div>
// //                   <h3 className="text-4xl font-bold text-gray-900 mb-2">30+</h3>
// //                   <p className="text-gray-600 text-sm">Projects Completed</p>
// //                 </div>
// //                 <div>
// //                   <h3 className="text-4xl font-bold text-gray-900 mb-2">70+</h3>
// //                   <p className="text-gray-600 text-sm">Years in Real Estate</p>
// //                 </div>
// //                 <div>
// //                   <h3 className="text-4xl font-bold text-gray-900 mb-2">3K+</h3>
// //                   <p className="text-gray-600 text-sm">Monthly Views</p>
// //                 </div>
// //               </div>

// //               {/* Features List */}
// //               <div className="space-y-6">
// //                 <div className="flex items-start space-x-4 p-4 bg-white rounded-lg hover:shadow-md transition-shadow duration-300">
// //                   <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
// //                     <Building2 className="w-6 h-6 text-gray-900" />
// //                   </div>
// //                   <div>
// //                     <h4 className="font-bold text-gray-900 mb-1">Expert Management</h4>
// //                     <p className="text-gray-600 text-sm">From leasing to maintenance, we handle it all with precision and care</p>
// //                   </div>
// //                 </div>

// //                 <div className="flex items-start space-x-4 p-4 bg-white rounded-lg hover:shadow-md transition-shadow duration-300">
// //                   <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
// //                     <Users className="w-6 h-6 text-gray-900" />
// //                   </div>
// //                   <div>
// //                     <h4 className="font-bold text-gray-900 mb-1">Trusted Agents</h4>
// //                     <p className="text-gray-600 text-sm">Experienced, responsive, and dedicated to guiding you every step of the way</p>
// //                   </div>
// //                 </div>

// //                 <div className="flex items-start space-x-4 p-4 bg-white rounded-lg hover:shadow-md transition-shadow duration-300">
// //                   <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
// //                     <Award className="w-6 h-6 text-gray-900" />
// //                   </div>
// //                   <div>
// //                     <h4 className="font-bold text-gray-900 mb-1">Tailored Listings</h4>
// //                     <p className="text-gray-600 text-sm">Customized property selections that match your unique needs and preferences</p>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Core Values Section */}
// //       <section className="py-20 px-6 bg-white">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="text-center mb-16">
// //             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
// //               [VALUES]
// //             </span>
// //             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
// //               What We Believe In
// //             </h2>
// //             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
// //               At Vedamsa, our core values—integrity, client focus, innovation, community, and excellence—guide everything we do to deliver exceptional real estate experiences.
// //             </p>
// //           </div>

// //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
// //             {coreValues.map((value, index) => (
// //               <div 
// //                 key={index}
// //                 className="group text-center p-8 bg-[#f5f3f0] rounded-xl hover:bg-white hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2"
// //               >
// //                 <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-white group-hover:bg-gray-900 text-gray-900 group-hover:text-white rounded-xl transition-all duration-500 shadow-md">
// //                   {value.icon}
// //                 </div>
// //                 <h3 className="text-xl font-bold text-gray-900 mb-4">{value.title}</h3>
// //                 <p className="text-gray-600 leading-relaxed">{value.description}</p>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Mission & Vision Section */}
// //       <section className="py-20 px-6 bg-[#f5f3f0]">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
// //             {/* Mission */}
// //             <div className="bg-white p-12 rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-500">
// //               <div className="w-16 h-16 bg-gray-900 text-white rounded-xl flex items-center justify-center mb-6">
// //                 <TrendingUp className="w-8 h-8" />
// //               </div>
// //               <h3 className="text-3xl font-bold text-gray-900 mb-6">Mission</h3>
// //               <p className="text-gray-600 leading-relaxed mb-6">
// //                 At Vedamsa, we redefine real estate with solutions that surpass expectations. Rooted in innovation, sustainability, and community living, we are committed to delivering quality, transparency, and unparalleled customer satisfaction.
// //               </p>
// //               <p className="text-gray-600 leading-relaxed">
// //                 With a proven track record of successful projects, Vedamsa is shaping Hyderabad's (Isnapur) urban landscape with vibrant spaces for residents and businesses alike. Experience the future of real estate with us!
// //               </p>
// //             </div>

// //             {/* Vision */}
// //             <div className="bg-white p-12 rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-500">
// //               <div className="w-16 h-16 bg-gray-900 text-white rounded-xl flex items-center justify-center mb-6">
// //                 <Award className="w-8 h-8" />
// //               </div>
// //               <h3 className="text-3xl font-bold text-gray-900 mb-6">Vision</h3>
// //               <p className="text-gray-600 leading-relaxed mb-6">
// //                 At Vedamsa, we deliver real estate solutions that surpass expectations. Guided by innovation, sustainability, and a commitment to community living, we focus on providing quality, transparency, and unmatched customer satisfaction.
// //               </p>
// //               <p className="text-gray-600 leading-relaxed">
// //                 With a proven track record in real estate and marketing, Vedamsa is setting new industry standards. Our dedication to excellence and sustainable practices is transforming Hyderabad's urban landscape, crafting vibrant and livable spaces for residents and businesses alike.
// //               </p>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* CTA Section */}
// //       <section className="py-20 px-6 bg-gray-900">
// //         <div className="max-w-4xl mx-auto text-center">
// //           <span className="text-sm uppercase tracking-[0.3em] text-gray-400 font-medium mb-6 block">
// //             [GET STARTED]
// //           </span>
// //           <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
// //             Book Your Dream Home
// //           </h2>
// //           <p className="text-gray-300 text-lg leading-relaxed mb-12">
// //             Ready to find your perfect space? Let's start your journey to modern living with Vedamsa's trusted expertise and personalized service.
// //           </p>
// //           <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
// //             <button className="group bg-white text-gray-900 px-10 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 flex items-center space-x-2 shadow-xl hover:shadow-2xl transform hover:-translate-y-1">
// //               <span>Schedule a Consultation</span>
// //               <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
// //             </button>
// //             <button className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300">
// //               View Properties
// //             </button>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Footer */}
// //       <footer className="bg-[#2d1f10] text-white py-12 px-6">
// //         <div className="max-w-7xl mx-auto text-center">
// //           <div className="flex items-center justify-center space-x-3 mb-6">
// //             <div className="bg-white text-gray-900 p-2 rounded">
// //               <Building2 className="w-6 h-6" />
// //             </div>
// //             <span className="text-2xl font-bold">Vedamsa</span>
// //           </div>
// //           <p className="text-gray-400 mb-4">Building Dreams, Creating Futures</p>
// //           <p className="text-gray-500 text-sm">© 2025 Vedamsa. All rights reserved.</p>
// //         </div>
// //       </footer>
// //     </div>
// //   );
// // };

// // export default VedamsaAboutPage;
// import React from 'react';
// import { Link } from 'react-router-dom';
// import { Building2, Users, Award, TrendingUp, CheckCircle, ArrowRight } from 'lucide-react';
// import post3 from  './Images/Maa_Garudadri_page_4_square.png';

// const AboutPage = () => {
//   const stats = [
//     { number: '30', suffix: '+', text: 'Projects Completed' },
//     { number: '70', suffix: '+', text: 'Happy Customers' },
//     { number: '3,000', suffix: '+', text: 'Upcoming Projects' },
//     { number: '2', suffix: '', text: 'Decades of Excellence' }
//   ];

//   const coreValues = [
//     {
//       icon: <Building2 className="w-12 h-12" />,
//       title: 'Quality',
//       description: 'We use the finest materials and employ stringent quality control measures to ensure that every project we undertake meets the highest standards of excellence.'
//     },
//     {
//       icon: <TrendingUp className="w-12 h-12" />,
//       title: 'Innovation',
//       description: 'We embrace new technologies and innovative construction methods to deliver projects that are aesthetically pleasing but also sustainable and durable.'
//     },
//     {
//       icon: <CheckCircle className="w-12 h-12" />,
//       title: 'Transparency',
//       description: 'We maintain open and honest communication with our clients, ensuring they are informed and involved at every stage of the construction process.'
//     },
//     {
//       icon: <Users className="w-12 h-12" />,
//       title: 'Community',
//       description: 'We are committed to contributing positively to the neighborhoods we serve, creating spaces where life unfolds and communities thrive.'
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-[#f5f3f0]">
//       {/* Hero Section with Split Layout */}
//       <section className="pt-32 pb-20 px-6">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//             {/* Left - Image */}
//             <div className="relative overflow-hidden rounded-2xl shadow-2xl group">
//               <img 
//                 src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800"
//                 alt="Modern Living Space"
//                 className="w-full h-[600px] object-cover transform group-hover:scale-105 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
//             </div>

//             {/* Right - Content */}
//             <div>
//               <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//                 [ABOUT]
//               </span>
//               <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
//                 Modern Living,<br />
//                 Thoughtfully Designed
//               </h1>
//               <p className="text-gray-600 text-lg leading-relaxed mb-8">
//                 At Vedamsa, our mission is to connect people with exceptional properties through transparent, trustworthy, and personalized service. We believe that finding a home is about more than just walls and roofs — it's about creating a space where life unfolds.
//               </p>
//               <Link 
//                 to="/contact"
//                 className="group inline-flex items-center space-x-2 bg-[#f5f3f0] border-2 border-gray-900 text-gray-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-900 hover:text-white transition-all duration-300"
//               >
//                 <span>Meet the Team</span>
//                 <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
//               </Link>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Legacy Section */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-6xl mx-auto text-center">
//           <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//             [OUR LEGACY]
//           </span>
//           <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
//             Nearly 30 Years of Excellence
//           </h2>
//           <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto mb-12">
//             Welcome to Vedamsa, a premier construction company in Hyderabad with a nearly 30-year legacy of excellence and trust. Over this period, Vedamsa has become synonymous with quality, reliability, and customer satisfaction in plotting and construction. With an impressive portfolio and a track record of over 3000 happy customers, we stand as a testament to what dedication, expertise, and commitment can achieve.
//           </p>
//         </div>
//       </section>

//       {/* Stats Section - Split Layout */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//             {/* Left - Image */}
//             <div className="relative overflow-hidden rounded-2xl shadow-2xl group order-2 lg:order-1">
//               <img 
//                 src={post3}
//                 alt="Our Commitment"
//                 className="w-full h-[700px] object-cover transform group-hover:scale-105 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
//             </div>

//             {/* Right - Stats & Content */}
//             <div className="order-1 lg:order-2">
//               <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//                 [WHY VEDAMSA]
//               </span>
//               <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//                 Our Commitment to You
//               </h2>
//               <p className="text-gray-600 text-lg leading-relaxed mb-12">
//                 Vedamsa empowers modern property management teams and real estate professionals to simplify operations, increase efficiency, and connect clients with their ideal homes—without unnecessary complexity.
//               </p>

//               {/* Stats Grid */}
//               <div className="grid grid-cols-3 gap-8 mb-12">
//                 <div>
//                   <h3 className="text-4xl font-bold text-gray-900 mb-2">30+</h3>
//                   <p className="text-gray-600 text-sm">Projects Completed</p>
//                 </div>
//                 <div>
//                   <h3 className="text-4xl font-bold text-gray-900 mb-2">70+</h3>
//                   <p className="text-gray-600 text-sm">Years in Real Estate</p>
//                 </div>
//                 <div>
//                   <h3 className="text-4xl font-bold text-gray-900 mb-2">3K+</h3>
//                   <p className="text-gray-600 text-sm">Monthly Views</p>
//                 </div>
//               </div>

//               {/* Features List */}
//               <div className="space-y-6">
//                 <div className="flex items-start space-x-4 p-4 bg-white rounded-lg hover:shadow-md transition-shadow duration-300">
//                   <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
//                     <Building2 className="w-6 h-6 text-gray-900" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-1">Expert Management</h4>
//                     <p className="text-gray-600 text-sm">From leasing to maintenance, we handle it all with precision and care</p>
//                   </div>
//                 </div>

//                 <div className="flex items-start space-x-4 p-4 bg-white rounded-lg hover:shadow-md transition-shadow duration-300">
//                   <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
//                     <Users className="w-6 h-6 text-gray-900" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-1">Trusted Agents</h4>
//                     <p className="text-gray-600 text-sm">Experienced, responsive, and dedicated to guiding you every step of the way</p>
//                   </div>
//                 </div>

//                 <div className="flex items-start space-x-4 p-4 bg-white rounded-lg hover:shadow-md transition-shadow duration-300">
//                   <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
//                     <Award className="w-6 h-6 text-gray-900" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-1">Tailored Listings</h4>
//                     <p className="text-gray-600 text-sm">Customized property selections that match your unique needs and preferences</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Core Values Section */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [VALUES]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               What We Believe In
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
//               At Vedamsa, our core values—integrity, client focus, innovation, community, and excellence—guide everything we do to deliver exceptional real estate experiences.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//             {coreValues.map((value, index) => (
//               <div 
//                 key={index}
//                 className="group text-center p-8 bg-[#f5f3f0] rounded-xl hover:bg-white hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2"
//               >
//                 <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-white group-hover:bg-gray-900 text-gray-900 group-hover:text-white rounded-xl transition-all duration-500 shadow-md">
//                   {value.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-4">{value.title}</h3>
//                 <p className="text-gray-600 leading-relaxed">{value.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Mission & Vision Section */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
//             {/* Mission */}
//             <div className="bg-white p-12 rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-500">
//               <div className="w-16 h-16 bg-gray-900 text-white rounded-xl flex items-center justify-center mb-6">
//                 <TrendingUp className="w-8 h-8" />
//               </div>
//               <h3 className="text-3xl font-bold text-gray-900 mb-6">Mission</h3>
//               <p className="text-gray-600 leading-relaxed mb-6">
//                 At Vedamsa, we redefine real estate with solutions that surpass expectations. Rooted in innovation, sustainability, and community living, we are committed to delivering quality, transparency, and unparalleled customer satisfaction.
//               </p>
//               <p className="text-gray-600 leading-relaxed">
//                 With a proven track record of successful projects, Vedamsa is shaping Hyderabad's (Isnapur) urban landscape with vibrant spaces for residents and businesses alike. Experience the future of real estate with us!
//               </p>
//             </div>

//             {/* Vision */}
//             <div className="bg-white p-12 rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-500">
//               <div className="w-16 h-16 bg-gray-900 text-white rounded-xl flex items-center justify-center mb-6">
//                 <Award className="w-8 h-8" />
//               </div>
//               <h3 className="text-3xl font-bold text-gray-900 mb-6">Vision</h3>
//               <p className="text-gray-600 leading-relaxed mb-6">
//                 At Vedamsa, we deliver real estate solutions that surpass expectations. Guided by innovation, sustainability, and a commitment to community living, we focus on providing quality, transparency, and unmatched customer satisfaction.
//               </p>
//               <p className="text-gray-600 leading-relaxed">
//                 With a proven track record in real estate and marketing, Vedamsa is setting new industry standards. Our dedication to excellence and sustainable practices is transforming Hyderabad's urban landscape, crafting vibrant and livable spaces for residents and businesses alike.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-20 px-6 bg-gray-900">
//         <div className="max-w-4xl mx-auto text-center">
//           <span className="text-sm uppercase tracking-[0.3em] text-gray-400 font-medium mb-6 block">
//             [GET STARTED]
//           </span>
//           <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
//             Book Your Dream Home
//           </h2>
//           <p className="text-gray-300 text-lg leading-relaxed mb-12">
//             Ready to find your perfect space? Let's start your journey to modern living with Vedamsa's trusted expertise and personalized service.
//           </p>
//           <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
//             <Link 
//               to="/contact"
//               className="group inline-flex items-center space-x-2 bg-white text-gray-900 px-10 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
//             >
//               <span>Schedule a Consultation</span>
//               <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
//             </Link>
//             <Link 
//               to="/contact"
//               className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300"
//             >
//               View Properties
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-[#2d1f10] text-white py-12 px-6">
//         <div className="max-w-7xl mx-auto text-center">
//           <div className="flex items-center justify-center space-x-3 mb-6">
//             <div className="bg-white text-gray-900 p-2 rounded">
//               <Building2 className="w-6 h-6" />
//             </div>
//             <span className="text-2xl font-bold">Vedamsa</span>
//           </div>
//           <p className="text-gray-400 mb-4">Building Dreams, Creating Futures</p>
//           <p className="text-gray-500 text-sm">© 2025 Vedamsa. All rights reserved.</p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default AboutPage;

import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Building2, Users, Award, TrendingUp, CheckCircle, ArrowRight } from 'lucide-react';
import post3 from  './Images/Maa_Garudadri_page_4_square.png';

// PURE SILVER Reveal Image Component
const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsRevealed(true);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
          isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
        }`}
        style={{ transitionDelay: '800ms' }}
      />
      
      {/* PURE SILVER Gradient Mask */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
          isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
        }`}
        style={{ 
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
          background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
        }}
      />
      
      {/* Silver Shimmer */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
          isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
        }`}
        style={{ 
          transitionDelay: '300ms',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
        }}
      />
    </div>
  );
};

// Reveal Content Component with Multiple Directions
const RevealContent = ({ children, className = "", delay = 0, direction = 'up' }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  const getTransform = () => {
    if (direction === 'up') return isRevealed ? 'translate-y-0' : 'translate-y-[60px]';
    if (direction === 'down') return isRevealed ? 'translate-y-0' : '-translate-y-[60px]';
    if (direction === 'left') return isRevealed ? 'translate-x-0' : 'translate-x-[60px]';
    if (direction === 'right') return isRevealed ? 'translate-x-0' : '-translate-x-[60px]';
    return '';
  };
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
      } ${getTransform()} ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

// Animated Counter Component
const AnimatedCounter = ({ end, suffix = '', duration = 2000, delay = 0 }) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(null);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && !hasStarted) {
          setHasStarted(true);
          setTimeout(() => {
            const endValue = typeof end === 'string' ? parseInt(end.replace(/,/g, '')) : end;
            const startTime = Date.now();
            const animate = () => {
              const now = Date.now();
              const progress = Math.min((now - startTime) / duration, 1);
              const easeOutQuart = 1 - Math.pow(1 - progress, 4);
              const current = Math.floor(easeOutQuart * endValue);
              setCount(current);
              if (progress < 1) {
                requestAnimationFrame(animate);
              } else {
                setCount(endValue);
              }
            };
            animate();
          }, delay);
        }
      },
      { threshold: 0.5 }
    );

    if (countRef.current) observer.observe(countRef.current);
    return () => {
      if (countRef.current) observer.unobserve(countRef.current);
    };
  }, [end, duration, delay, hasStarted]);

  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return (
    <span ref={countRef}>
      {formatNumber(count)}{suffix}
    </span>
  );
};

const AboutPage = () => {
  const stats = [
    { number: '30', suffix: '+', text: 'Projects Completed' },
    { number: '70', suffix: '+', text: 'Years Experience' },
    { number: '3000', suffix: '+', text: 'Happy Customers' },
    { number: '2', suffix: '', text: 'Upcoming Projects' }
  ];

  const coreValues = [
    {
      icon: <Building2 className="w-10 h-10 sm:w-12 sm:h-12" />,
      title: 'Quality',
      description: 'We use the finest materials and employ stringent quality control measures to ensure that every project we undertake meets the highest standards of excellence.'
    },
    {
      icon: <TrendingUp className="w-10 h-10 sm:w-12 sm:h-12" />,
      title: 'Innovation',
      description: 'We embrace new technologies and innovative construction methods to deliver projects that are aesthetically pleasing but also sustainable and durable.'
    },
    {
      icon: <CheckCircle className="w-10 h-10 sm:w-12 sm:h-12" />,
      title: 'Transparency',
      description: 'We maintain open and honest communication with our clients, ensuring they are informed and involved at every stage of the construction process.'
    },
    {
      icon: <Users className="w-10 h-10 sm:w-12 sm:h-12" />,
      title: 'Community',
      description: 'We are committed to contributing positively to the neighborhoods we serve, creating spaces where life unfolds and communities thrive.'
    }
  ];

  const features = [
    {
      icon: <Building2 className="w-6 h-6" />,
      title: 'Expert Management',
      description: 'From leasing to maintenance, we handle it all with precision and care'
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: 'Trusted Agents',
      description: 'Experienced, responsive, and dedicated to guiding you every step of the way'
    },
    {
      icon: <Award className="w-6 h-6" />,
      title: 'Tailored Listings',
      description: 'Customized property selections that match your unique needs and preferences'
    }
  ];

  return (
    <div className="min-h-screen bg-[#f5f3f0] overflow-x-hidden">
      {/* Hero Section with Split Layout */}
      <section className="pt-24 sm:pt-32 pb-12 sm:pb-20 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* Left - Image */}
            <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[400px] sm:h-[500px] lg:h-[600px]">
              <RevealImage 
                src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800"
                alt="Modern Living Space"
                className="w-full h-full"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              
              {/* Floating Badge */}
              <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm px-4 sm:px-6 py-2 sm:py-3 rounded-xl shadow-xl">
                <p className="text-xs sm:text-sm font-bold text-gray-900">30+ Years of Excellence</p>
              </div>
            </div>

            {/* Right - Content */}
            <div>
              <RevealContent direction="right">
                <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
                  [ABOUT VEDAMSA]
                </span>
              </RevealContent>
              <RevealContent delay={100} direction="right">
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                  Modern Living,<br />
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">
                    Thoughtfully Designed
                  </span>
                </h1>
              </RevealContent>
              <RevealContent delay={200} direction="right">
                <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
                  At Vedamsa, our mission is to connect people with exceptional properties through transparent, trustworthy, and personalized service. We believe that finding a home is about more than just walls and roofs — it's about creating a space where life unfolds.
                </p>
              </RevealContent>
              <RevealContent delay={300} direction="right">
                <Link 
                  to="/contact"
                  className="group inline-flex items-center space-x-2 bg-gradient-to-r from-[#8B7355] to-[#6B5744] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-1 hover:scale-105 relative overflow-hidden"
                >
                  <span className="relative z-10">Meet the Team</span>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300 relative z-10" />
                  <div className="absolute inset-0 bg-gradient-to-r from-[#6B5744] to-[#8B7355] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </Link>
              </RevealContent>
            </div>
          </div>
        </div>
      </section>

      {/* Legacy Section */}
      <section className="py-12 sm:py-20 px-4 sm:px-6 bg-white relative overflow-hidden">
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, #8B7355 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}
        ></div>
        
        <div className="max-w-6xl mx-auto text-center relative z-10">
          <RevealContent>
            <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
              [OUR LEGACY]
            </span>
          </RevealContent>
          <RevealContent delay={100}>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 sm:mb-8">
              Nearly <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">30 Years</span> of Excellence
            </h2>
          </RevealContent>
          <RevealContent delay={200}>
            <p className="text-gray-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-4xl mx-auto mb-8 sm:mb-12 px-4">
              Welcome to Vedamsa, a premier construction company in Hyderabad with a nearly 30-year legacy of excellence and trust. Over this period, Vedamsa has become synonymous with quality, reliability, and customer satisfaction in plotting and construction. With an impressive portfolio and a track record of over 3000 happy customers, we stand as a testament to what dedication, expertise, and commitment can achieve.
            </p>
          </RevealContent>

          {/* Animated Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
            {stats.map((stat, index) => (
              <RevealContent key={index} delay={300 + (index * 100)} direction="up">
                <div className="bg-[#f5f3f0] p-6 sm:p-8 rounded-2xl hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 group">
                  <div className="text-4xl sm:text-5xl md:text-6xl font-bold mb-2 sm:mb-3 bg-clip-text text-transparent bg-gradient-to-br from-[#8B7355] via-[#C0C0C0] to-[#E8E8E8] group-hover:scale-110 transition-transform duration-500">
                    <AnimatedCounter end={stat.number} suffix={stat.suffix} delay={300 + (index * 100)} />
                  </div>
                  <p className="text-gray-600 text-xs sm:text-sm font-medium">{stat.text}</p>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section - Split Layout */}
      <section className="py-12 sm:py-20 px-4 sm:px-6 bg-[#f5f3f0]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* Left - Image */}
            <div className="relative overflow-hidden rounded-2xl shadow-2xl group order-2 lg:order-1 h-[500px] sm:h-[600px] lg:h-[700px]">
              <RevealImage 
                src={post3}
                alt="Our Commitment"
                className="w-full h-full"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
              
              {/* Floating Stats Badge */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm p-4 sm:p-6 rounded-xl shadow-2xl">
                <div className="grid grid-cols-3 gap-4">
                  <div className="text-center">
                    <p className="text-2xl sm:text-3xl font-bold text-[#8B7355]">30+</p>
                    <p className="text-xs sm:text-sm text-gray-600">Projects</p>
                  </div>
                  <div className="text-center border-x border-gray-200">
                    <p className="text-2xl sm:text-3xl font-bold text-[#8B7355]">70+</p>
                    <p className="text-xs sm:text-sm text-gray-600">Years</p>
                  </div>
                  <div className="text-center">
                    <p className="text-2xl sm:text-3xl font-bold text-[#8B7355]">3K+</p>
                    <p className="text-xs sm:text-sm text-gray-600">Customers</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right - Content */}
            <div className="order-1 lg:order-2">
              <RevealContent direction="left">
                <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
                  [WHY VEDAMSA]
                </span>
              </RevealContent>
              <RevealContent delay={100} direction="left">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Our Commitment to <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">You</span>
                </h2>
              </RevealContent>
              <RevealContent delay={200} direction="left">
                <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-8 sm:mb-12">
                  Vedamsa empowers modern property management teams and real estate professionals to simplify operations, increase efficiency, and connect clients with their ideal homes—without unnecessary complexity.
                </p>
              </RevealContent>

              {/* Features List */}
              <div className="space-y-4 sm:space-y-6">
                {features.map((feature, index) => (
                  <RevealContent key={index} delay={300 + (index * 100)} direction="left">
                    <div className="flex items-start space-x-3 sm:space-x-4 p-4 sm:p-6 bg-white rounded-xl hover:shadow-xl transition-all duration-500 transform hover:-translate-y-1 group">
                      <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#8B7355] to-[#6B5744] rounded-xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg text-white">
                        {feature.icon}
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base group-hover:text-[#8B7355] transition-colors duration-300">
                          {feature.title}
                        </h4>
                        <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </RevealContent>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="py-12 sm:py-20 px-4 sm:px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
                [CORE VALUES]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
                What We <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Believe In</span>
              </h2>
            </RevealContent>
            <RevealContent delay={200}>
              <p className="text-gray-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-4xl mx-auto px-4">
                At Vedamsa, our core values—integrity, client focus, innovation, community, and excellence—guide everything we do to deliver exceptional real estate experiences.
              </p>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {coreValues.map((value, index) => (
              <RevealContent 
                key={index} 
                delay={index * 150}
                direction={index === 0 ? 'right' : index === 3 ? 'left' : 'up'}
              >
                <div className="group relative text-center p-6 sm:p-8 bg-[#f5f3f0] rounded-2xl hover:bg-white hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-[#8B7355]/5 to-[#6B5744]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
                  <div className="relative z-10">
                    <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 mb-4 sm:mb-6 bg-white group-hover:bg-gradient-to-br group-hover:from-[#8B7355] group-hover:to-[#6B5744] text-gray-900 group-hover:text-white rounded-xl transition-all duration-500 shadow-md group-hover:shadow-2xl group-hover:scale-110 group-hover:rotate-6">
                      {value.icon}
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 group-hover:text-[#8B7355] transition-colors duration-300">
                      {value.title}
                    </h3>
                    <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                      {value.description}
                    </p>
                  </div>

                  <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-[#8B7355]/10 to-transparent rounded-bl-full transform translate-x-10 -translate-y-10 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500"></div>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-12 sm:py-20 px-4 sm:px-6 bg-[#f5f3f0]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12">
            {/* Mission */}
            <RevealContent delay={100} direction="right">
              <div className="relative bg-white p-8 sm:p-10 lg:p-12 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group overflow-hidden h-full">
                <div className="absolute inset-0 bg-gradient-to-br from-[#8B7355]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative z-10">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-[#8B7355] to-[#6B5744] text-white rounded-xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                    <TrendingUp className="w-7 h-7 sm:w-8 sm:h-8" />
                  </div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6 group-hover:text-[#8B7355] transition-colors duration-300">
                    Mission
                  </h3>
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-4 sm:mb-6">
                    At Vedamsa, we redefine real estate with solutions that surpass expectations. Rooted in innovation, sustainability, and community living, we are committed to delivering quality, transparency, and unparalleled customer satisfaction.
                  </p>
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                    With a proven track record of successful projects, Vedamsa is shaping Hyderabad's (Isnapur) urban landscape with vibrant spaces for residents and businesses alike. Experience the future of real estate with us!
                  </p>
                </div>

                <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tl from-[#8B7355]/5 to-transparent rounded-tl-full transform translate-x-16 translate-y-16 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500"></div>
              </div>
            </RevealContent>

            {/* Vision */}
            <RevealContent delay={250} direction="left">
              <div className="relative bg-white p-8 sm:p-10 lg:p-12 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group overflow-hidden h-full">
                <div className="absolute inset-0 bg-gradient-to-br from-[#6B5744]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative z-10">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-[#6B5744] to-[#8B7355] text-white rounded-xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                    <Award className="w-7 h-7 sm:w-8 sm:h-8" />
                  </div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6 group-hover:text-[#8B7355] transition-colors duration-300">
                    Vision
                  </h3>
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-4 sm:mb-6">
                    At Vedamsa, we deliver real estate solutions that surpass expectations. Guided by innovation, sustainability, and a commitment to community living, we focus on providing quality, transparency, and unmatched customer satisfaction.
                  </p>
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                    With a proven track record in real estate and marketing, Vedamsa is setting new industry standards. Our dedication to excellence and sustainable practices is transforming Hyderabad's urban landscape, crafting vibrant and livable spaces for residents and businesses alike.
                  </p>
                </div>

                <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tl from-[#6B5744]/5 to-transparent rounded-tl-full transform translate-x-16 translate-y-16 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500"></div>
              </div>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-20 sm:py-32 px-4 sm:px-6 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-fixed"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#8B7355]/95 to-[#6B5744]/90"></div>
        
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
            backgroundSize: '50px 50px',
            animation: 'movePattern 20s linear infinite'
          }}
        ></div>

        <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
          <RevealContent>
            <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-white/80 font-bold mb-4 sm:mb-6 block">
              [GET STARTED]
            </span>
          </RevealContent>
          <RevealContent delay={100}>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 sm:mb-8">
              Book Your Dream Home
            </h2>
          </RevealContent>
          <RevealContent delay={200}>
            <p className="text-white/90 text-base sm:text-lg md:text-xl leading-relaxed mb-8 sm:mb-12 px-4">
              Ready to find your perfect space? Let's start your journey to modern living with Vedamsa's trusted expertise and personalized service.
            </p>
          </RevealContent>
          <RevealContent delay={300}>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
              <Link 
                to="/contact"
                className="group inline-flex items-center space-x-2 bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 hover:scale-105 text-base sm:text-lg"
              >
                <span>Schedule a Consultation</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
              </Link>
              <Link 
                to="/contact"
                className="bg-transparent border-2 border-white text-white px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-white hover:text-gray-900 transition-all duration-500 text-base sm:text-lg"
              >
                View Properties
              </Link>
            </div>
          </RevealContent>
        </div>
      </section>

      {/* Footer */}
      {/* <footer className="bg-[#1a1410] text-white py-12 px-4 sm:px-6 relative overflow-hidden">
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: 'linear-gradient(30deg, #8B7355 12%, transparent 12.5%, transparent 87%, #8B7355 87.5%)',
            backgroundSize: '80px 140px'
          }}
        ></div>

        <div className="max-w-7xl mx-auto text-center relative z-10">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="bg-gradient-to-br from-[#8B7355] to-[#6B5744] text-white p-2 rounded-lg shadow-lg">
              <Building2 className="w-6 h-6" />
            </div>
            <span className="text-2xl font-bold">Vedamsa</span>
          </div>
          <p className="text-gray-400 mb-4">Building Dreams, Creating Futures</p>
          <p className="text-gray-500 text-sm">© 2025 Vedamsa. All rights reserved.</p>
        </div>
      </footer> */}

      <style jsx>{`
        @keyframes movePattern {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(50px, 50px);
          }
        }
      `}</style>
    </div>
  );
};

export default AboutPage;